import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Global HubSpot chat manager.
 * On /suggestionsAI, the inline logic is handled entirely by InlineHubSpotChat.
 * This component only ensures the floating widget loads on all other pages.
 */
const HubSpotChatManager = () => {
  const location = useLocation();
  const isSuggestionsPage = location.pathname === "/suggestionsAI";

  useEffect(() => {
    // On /suggestionsAI, InlineHubSpotChat owns the widget lifecycle — do nothing here.
    if (isSuggestionsPage) return;

    const win = window as any;

    const getBriefEmail = (): string | null => {
      try {
        for (let i = 0; i < sessionStorage.length; i++) {
          const key = sessionStorage.key(i);
          if (key && key.startsWith("brief_data_")) {
            const raw = sessionStorage.getItem(key);
            if (raw) {
              const parsed = JSON.parse(raw);
              if (parsed?.email) return parsed.email;
            }
          }
        }
      } catch {
        // ignore
      }
      return null;
    };

    const email = getBriefEmail();
    if (email) {
      win._hsq = win._hsq || [];
      win._hsq.push(["identify", { email }]);
      win._hsq.push(["trackPageView"]);
    }

    // Ensure floating mode settings
    if (win.hsConversationsSettings) {
      delete win.hsConversationsSettings.inlineEmbedSelector;
    }
    if (email) {
      win.hsConversationsSettings = {
        ...(win.hsConversationsSettings || {}),
        identificationEmail: email,
      };
    }
    // Remove any leftover inline hide style
    document.getElementById("hubspot-inline-override")?.remove();

    const loadFloating = () => {
      if (win.HubSpotConversations?.widget) {
        try {
          win.HubSpotConversations.widget.load();
        } catch (_) {}
      }
    };

    if (win.HubSpotConversations?.widget) {
      loadFloating();
    } else {
      const poll = window.setInterval(() => {
        if (win.HubSpotConversations?.widget) {
          clearInterval(poll);
          loadFloating();
        }
      }, 500);
      const timeout = window.setTimeout(() => clearInterval(poll), 30000);
      return () => {
        clearInterval(poll);
        clearTimeout(timeout);
      };
    }
  }, [isSuggestionsPage]);

  return null;
};

export default HubSpotChatManager;
